export default __webpack_public_path__ + "static/media/logo_barra.f0cf4b1a.jfif";